const propertiesSectionData = [

  // Start Egypt

  {
    id: "2",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Dubai-1.jpg"),
    subImage: [
      require("../../assets/projects/Dubai-2.jpg"),
      require("../../assets/projects/Dubai-3.webp"),
      require("../../assets/projects/Dubai-4.jpg"),
      require("../../assets/projects/Dubai-5.jpg"),
    ],
    title: "Mr C Residences Downtown Dubai",
    statues: "Status : Completed",
    price: "Starting From 2.210,000 $",
    completionDate: "Expected Completion",
    placeName: "Mr C Residences Downtown",
    area: " 2,225 to 5,614 Sqft",
    bedroom: "2 / 3 / 4 ",
    locationLink: "https://maps.app.goo.gl/Si13DsNhovaBA5Kf6",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d57760.431500914056!2d55.267058!3d25.202313000000004!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDEyJzAzLjkiTiA1NcKwMTYnMDAuOCJF!5e0!3m2!1sen!2sus!4v1741112045381!5m2!1sen!2sus",
    overview: [
      {
        id: "1",
        title: "Mr C Residences Downtown Dubai Overview",
        details: "Mr. C Residences Downtown Dubai is a masterfully designed luxury residential project that brings the charm of classic European hospitality to the dynamic skyline of Dubai. C brand, this development embodies sophistication, understated elegance, and world-class service, redefining exclusive urban living in the city’s most prestigious neighborhood."
      },
      {
        id: "2",
        title: "Exquisite Residences with Iconic Views",
        details: "Designed for the modern cosmopolitan, Mr. C Residences Downtown Dubai offers an exclusive selection of spacious 2, 3, and 4-bedroom apartments, duplexes, and penthouses. Each residence is meticulously crafted with open-plan interiors, floor-to-ceiling windows, and expansive terraces, providing breathtaking views of Burj Khalifa, Dubai Fountain, and the city’s vibrant skyline. The interiors reflect a refined aesthetic, blending contemporary luxury with timeless European influences, featuring high-end materials, bespoke detailing, and elegant finishes that exude sophistication."
      },
      {
        id: "3",
        title: "Prime Location with Seamless Connectivity",
        details: "Nestled in the heart of Downtown Dubai, this prestigious address places residents at the epicenter of the citys vibrant lifestyle. With immediate access to Dubai Mall, Dubai Opera, and the financial district, as well as major road networks like Sheikh Zayed Road, connectivity to Business Bay, DIFC, and Dubai Marina is effortless. Whether for business, leisure, or entertainment, residents are always moments away from the best Dubai has to offer."
      },
      {
        id: "4",
        title: "A Legacy of Luxury & Investment Opportunity",
        details: "Mr. C Residences Downtown Dubai is not just a home—it is a statement of refined living, curated luxury, and enduring value. With high investment potential, premium rental demand, and the prestige of the Mr. C brand, this development is a rare opportunity for discerning buyers seeking an unparalleled lifestyle in one of the worlds most sought-after destinations."
      },
    ],
    approximateLocations: [
      "Luxury and High-end Finishing",
      "Central A/C",
      "CCTV Cameras",
      "Security",
    ]
  },

  {
    id: "15",
    city: "Muscat",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Trump-6.jpg"),
    subImage: [
      require("../../assets/projects/Trump-2.jpg"),
      require("../../assets/projects/Trump-3.jpg"),
      require("../../assets/projects/Trump-5.jpg"),
    ],
    title: "AIDA Trump Hotel",
    statues: "Status : Under Development",
    price: "Starting From OMR 177,560",
    completionDate: "Expected Completion Date December 2028",
    placeName: "Trump International Hotel",
    area: "43 to 138",
    bedroom: "Rooms, Junior Suites",
    locationLink: "https://maps.app.goo.gl/hUcRn8LSwRB64Eqi9",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d12304.478444188919!2d58.677218157261!3d23.527346804900585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741117910150!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Invest in Trump Hotel Rooms & Suites",
        details: "Investing in a room within Trump Hotels puts you at the heart of it all with expert management and investment safety. The Trump International Hotel, Oman encompasses a luxury hotel, hanging suites with stunning views, furnished residences, a championship golf course, a members-only club, and the Cliff Night Club. Trump Hotels personal mission is to deliver unparalleled service and experiences so that you never have to settle for anything less than extraordinary. In addition to a luxury investment, you have the exclusive privilege of enjoying two weeks a year for personal indulgence."
      },
    ],
    approximateLocations: [
      "Trump International Golf Club",
      "Trump Member Club",
      "The Cliff Night Club",
      "AIDA Beach",
    ]
  },

  {
    id: "25",
    city: "Riyadh",
    countries: "KSA",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/KSA.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Neptune-1.jpg"),
    subImage: [
      require("../../assets/projects/Neptune-2.jpg"),
      require("../../assets/projects/Neptune-3.jpg"),
      require("../../assets/projects/Neptune-4.jpg"),
      require("../../assets/projects/Neptune-5.jpg"),
      require("../../assets/projects/Neptune-6.jpg"),
    ],
    title: "Neptune, Interiors",
    statues: "Status : Under Development",
    price: "Starting From SAR 4,440,421",
    completionDate: "Expected Completion Date 2027",
    placeName: "Neptune, Interiors",
    area: "300 to 420",
    bedroom: "5 Bedrooms",
    locationLink: "https://maps.app.goo.gl/b81TkA9Y5iFcfHLv6",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d68899.66872704582!2d46.777179783531274!3d24.82650061020001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDUwJzMzLjgiTiA0NsKwNDQnMTYuOCJF!5e0!3m2!1sar!2sjo!4v1741122918614!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Brilliant by design",
        details: "Discover an unparalleled fusion of artistry and living at the Neptune Villas. Located in the North of Riyadh, this exclusive collection is a tribute to timeless elegance and sophisticated design, Mouawad. Known for its rich heritage and exquisite craftsmanship, Mouawad brings its signature brilliance to these extraordinary villas."
      },
    ],
    approximateLocations: [
      "Schools",
      "Community Centre",
      "Sports Hub",
      "Restaurants and Cafes",
    ]
  },

  {
    id: "1",
    city: "New Cairo",
    countries: "Egypt",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Egypt.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/1-Montenapoleone (1).webp"),
    subImage: [
      require("../../assets/projects/1-Montenapoleone (2).webp"),
      require("../../assets/projects/1-Montenapoleone (3).webp"),
      require("../../assets/projects/1-Montenapoleone (4).webp"),
      require("../../assets/projects/1-Montenapoleone (5).webp"),
      require("../../assets/projects/1-Montenapoleone (6).webp"),
    ],
    title: "Montenapoleone",
    statues: "Status : Completed",
    price: "Starting From 251,316 $",
    completionDate: "Expected Completion Date June 2027 ",
    placeName: "Montenapoleone",
    area: "Area(SQM) 485.22",
    bedroom: "5-Bedroom ",
    areaShow: "485.22 Sqft",
    bedShow: "5 Bedroom",
    locationLink: "https://maps.app.goo.gl/Cak17u3V5WDLrLLS9",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d652.6133614320343!2d31.63745001638033!3d30.05337498450131!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1458234c24c14257%3A0x81771b50706c3799!2sMontenapoleone%20by%20Reportage%20Egypt!5e1!3m2!1sar!2sjo!4v1741003027042!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Montenapoleone",
        details: "In partnership with Al Ahly Sabbour, we are pleased to introduce our first project on Egyptian lands as Egypt, and in one of the most sought-after locations, Mostakbal City – The new heart of New Cairo. ​ Montenapoleone, inspired by the renowned fashion street in Milan, represents a microcosm of Italy, and a reflection of Italian beauty on Egyptian lands. Spanning over an area of approximately 465.000 m2, the project incorporates a wide range of high-end residential and commercial areas, within 62% open spaces, to offer you the best of what a vibrant life has to offer."
      },
      {
        id: "2",
        title: "Montenapoleone .. Beauty speaks Italian!",
        details: "The residential area incorporates a number of 374 townhouses and multiple residential buildings that offer simplex and duplex units with various sizes ranging between 1B, 2B, 3B, and 4B apartments, and private gardens for selected units. The contemporary designs, modern facades, and high-quality finishing speak of Italian beauty and set the standards for high-quality living, offering a masterpiece to call home."
      },
    ],
    approximateLocations: [
      "Mixed-use Development",
      "Phase 1 completion Date 2027",
      "Units 3 to 7-bedrooms",
      "Area from (sqft) 1,345",
    ]
  },

  // End Egypt

  {
    id: "11",
    city: "Doha",
    countries: "Qatar",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Qatar.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Vagues-1.jpg"),
    subImage: [
      require("../../assets/projects/Vagues-2.jpg"),
      require("../../assets/projects/Vagues3.jpg"),
      require("../../assets/projects/Vagues-4.jpg"),
      require("../../assets/projects/Vagues-5.jpg"),
      require("../../assets/projects/Vagues-6.jpg"),
    ],
    title: "Les Vagues 02",
    statues: "Status : Under Development",
    price: "Starting From QAR 3,200,000",
    completionDate: "Expected Completion Date Dec 2027",
    placeName: "Les Vagues 02",
    area: "94 to 165",
    bedroom: "2 bedrooms",
    locationLink: "https://maps.app.goo.gl/muxSmiiesQ34C8xM9",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d115330.1459689848!2d51.60415426409355!3d25.40256571973277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDI1JzM1LjQiTiA1McKwMzEnMzEuNSJF!5e0!3m2!1sar!2sjo!4v1741116246509!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Les Vagues 02",
        details: "Les Vagues 02 embodies the essence of island living, offering exclusively designed 2-bedroom sea-front residences adorned with magnificent terraces. Rising elegantly from the sandy shores, its sleek and contemporary architecture is complemented by the gentle presence of hand-picked palms and lush tropical greenery, creating a harmonious blend of modernity and natural beauty."
      },

    ],
    approximateLocations: [
      "Waterfront residences",
      "Floor to ceiling windows",
      "Staggered balconies",
      "Interiors",
    ]
  },

  // Start UAE
  {
    id: "3",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Cove-1.jpg"),
    subImage: [
      require("../../assets/projects/Cove-2.webp"),
      require("../../assets/projects/Cove-3.webp"),
      require("../../assets/projects/Cove-4.webp"),
      require("../../assets/projects/Cove-5.webp"),
      require("../../assets/projects/Cove-6.webp"),
      require("../../assets/projects/Cove-7.webp"),
      require("../../assets/projects/Cove-8.jpeg"),
    ],
    title: "Ellington Cove at Dubai Islands",
    statues: "Status : Completed",
    price: "Starting From 599,000 $",
    completionDate: "Expected Completion",
    placeName: "Ellington Cove at Dubai Islands",
    area: "social areas",
    bedroom: "2 / 3 / 4 ",
    locationLink: "https://maps.app.goo.gl/PSegdhhxwTSCfZpT6",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d115432.23453772892!2d55.292838!3d25.295557!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDE3JzQ0LjAiTiA1NcKwMTcnMzQuMiJF!5e0!3m2!1sen!2sus!4v1741112510276!5m2!1sen!2sus",
    overview: [
      {
        id: "1",
        title: "Ellington Cove",
        details: "Ellington Cove is nestled along the pristine shores of Dubai Islands, where the soothing rhythm of the waves meets masterful design. As Ellington’s inaugural project in this community, it offers a sanctuary of sophisticated coastal living. Featuring meticulously designed homes and innovative amenities, Ellington Cove seamlessly blends elegance, tranquility, and a deep connection to nature."
      },
      {
        id: "2",
        title: "",
        details: "Each residence at Ellington Cove is a gateway to the ultimate beachfront lifestyle. Designed with a perfect balance of sophistication, comfort, and practicality, these homes are tailored for those who wish to embrace the calm and beauty of coastal living."
      },
      {
        id: "3",
        title: "",
        details: "The architecture of Ellington Cove exudes simplicity and refinement. Palm-lined pathways surround a structure that harmonizes with its natural environment, where sleek, modern lines are complemented. The outdoor spaces are thoughtfully designed to enhance the beauty of the surroundings and foster a sense of connection."
      },
      {
        id: "4",
        title: "",
        details: "Residents enjoy exclusive access to a private beach, multiple swimming pools, a cutting-edge fitness and yoga studio, and beautifully landscaped gardens. The community offers serene family spaces alongside vibrant social areas, all thoughtfully crafted to encourage relaxation and interaction. With dedicated indoor and outdoor kids’ play zones, a water activity area, and bespoke leisure facilities, Ellington Cove reimagines the essence of seaside living."
      },
      {
        id: "5",
        title: "",
        details: "Nestled along the serene edges of Dubai Islands, Ellington Cove is a luxurious sanctuary where life flows seamlessly with the soothing rhythm of the sea. As the newest gem in Ellingtons prestigious collection, this exclusive development redefines coastal living with a perfect blend of modern sophistication and timeless beachfront elegance."
      },
      {
        id: "6",
        title: "",
        details: "Ellington Cove offers more than just private beach access—it delivers a resort-inspired lifestyle crafted for those who value tranquility and refinement. Here, indulgence and convenience take center stage, providing an environment where leisure, relaxation, and community thrive within an exceptional setting."
      },
      {
        id: "7",
        title: "",
        details: "Select from an array of options, including studios, one, two, and three-bedroom apartments, along with four-bedroom penthouses, each offering private beach access."
      },

    ],
    approximateLocations: [
      "Luxury and High-end Finishing",
      "Gym",
      "Central A/C",
      "CCTV Cameras",
      "Beach Access",
      "Waterfront",
    ]
  },
  {
    id: "4",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Palm-1.jpg"),
    subImage: [
      require("../../assets/projects/Palm-2.jpg"),
      require("../../assets/projects/Palm-4.jpg"),
      require("../../assets/projects/Palm-6.jpg"),
      require("../../assets/projects/Palm-7.jpg"),
    ],
    title: "Palm Jebel Ali Dubai - Luxury Villas for sale",
    statues: "Status : Completed",
    price: "Starting From AED 11,535,840",
    completionDate: "Expected Completion",
    placeName: "Palm Jebel Ali",
    area: "Sqft",
    bedroom: "6 Beds",
    locationLink: "https://maps.app.goo.gl/hG9MvrkhSguVtLPA9",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d115708.90050701196!2d54.990724!3d25.003407!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDAwJzEyLjMiTiA1NMKwNTknMjYuNiJF!5e0!3m2!1sen!2sus!4v1741113056634!5m2!1sen!2sus",
    overview: [
      {
        id: "1",
        title: "Palm Jebel Ali Villas",
        details: "Nestled amidst the vibrant city of Dubai, Palm Jebel Ali Dubai emerges as a serene sanctuary, offering a harmonious blend of luxury living and sustainable practices. The visionary creators of Palm Jumeirah, redefines the concept of beachfront living, promising an unparalleled lifestyle experience."
      },
      {
        id: "2",
        title: "A Haven of Tranquility",
        details: "Palm Jebel Ali Dubai, a captivating archipelago located in the south of Jebel Ali Free Zone, provides an idyllic escape from the bustling city center. Its tranquil ambiance, embraced waters of the Arabian Gulf, invites residents to immerse themselves in a world of serenity and relaxation. Yet, despite its secluded appeal, Palm Jebel Ali remains conveniently accessible via Sheikh Zayed Road, ensuring easy connectivity to all that Dubai has to offer."
      },
      {
        id: "3",
        title: "A Symphony of Luxury and Sustainability",
        details: "This extraordinary development comprises seven islands and 16 fronds, stretching over an impressive 68 miles of pristine coastline. Residents are enveloped in a world of luxury, with an abundance of world-class amenities catering to every lifestyle preference. Recreation zones, aqua sports facilities, cycling and pedestrian tracks, beach camping areas, and family spaces provide endless opportunities for leisure and recreation. Over 80 resorts and hotels, along with F&B and leisure venues, ensure a vibrant and diverse community."
      },
    ],
    approximateLocations: [
      "Luxury and High-end Finishing",
      "Central A/C",
      "CCTV Cameras",
      "Beach Access",
      "Private Beach",
      "Landmark View",
      "Waterfront",
    ]
  },
  {
    id: "5",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Downtown-1.webp"),
    subImage: [
      require("../../assets/projects/Downtown-2.webp"),
    ],
    title: "Address Grand",
    statues: "Status : Under Development",
    price: "Starting From 4.760,000 $",
    completionDate: "completed in 2028",
    placeName: "Address Grand",
    area: "763Sqft",
    bedroom: "4",
    locationLink: "https://maps.app.goo.gl/H9ZN74B6nsrhNn2N8",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d115529.74753498136!2d55.27717200000001!3d25.192948!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDExJzM0LjYiTiA1NcKwMTYnMzcuOCJF!5e0!3m2!1sen!2sus!4v1741113356883!5m2!1sen!2sus",
    overview: [
      {
        id: "1",
        title: "Address Grand",
        details: "Address Grand redefines luxury living in Downtown Dubai. This 56-story tower seamlessly blends contemporary architecture with an unparalleled lifestyle, offering a perfect vantage point in the heart of the city’s iconic district."
      },
      {
        id: "2",
        title: "",
        details: "Whether youre seeking a premium address or a lucrative investment, Address Grand  offers a rare opportunity to live amidst Dubais most coveted landmarks."
      },
    ],
    approximateLocations: [
      "Luxury and High-end Finishing",
      "Gym",
      "Central A/C",
      "Covered Parking",
      "Shared Pool",
    ]
  },


  {
    id: "6",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Marina-1.webp"),
    subImage: [
      require("../../assets/projects/Marina-2.jpg"),
      require("../../assets/projects/Marina-3.webp"),
      require("../../assets/projects/Marina-4.webp"),
      require("../../assets/projects/Marina-5.webp"),
    ],
    title: "Marina Cove",
    statues: "Status : Coming Soon",
    price: "Starting From AED 2,030,000",
    completionDate: "Oct 2029",
    placeName: "Marina Cove",
    area: "798 to 2,418 Sqft",
    bedroom: "1 to 4",
    locationLink: "https://maps.app.goo.gl/JSzkE7x6qw6dcxhj7",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d115638.59483759168!2d55.142236!3d25.077949!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDA0JzQwLjYiTiA1NcKwMDgnMzIuMSJF!5e0!3m2!1sen!2sus!4v1741113785609!5m2!1sen!2sus",
    overview: [
      {
        id: "1",
        title: "Marina Cove",
        details: "Marina Cove Apartments, located in the prestigious Dubai Marina, is a modern residential development offering a range of luxury apartments with stunning views of the marina and the Dubai skyline. This waterfront property provides a selection of 1-bedroom, 2-bedroom, and 3-bedroom apartments, all designed with contemporary architecture and high-quality finishes to cater to sophisticated urban living."
      },
      {
        id: "2",
        title: "",
        details: "Residents at Marina Cove enjoy a variety of top-tier amenities, including a swimming pool, fitness center, landscaped gardens, and 24-hour security. The apartments feature spacious layouts, floor-to-ceiling windows, and private balconies, enhancing the overall living experience with breathtaking views."
      },
      {
        id: "3",
        title: "",
        details: "The prime location in Dubai Marina offers easy access to a wide range of restaurants, cafes, retail outlets, and entertainment options. It is also conveniently connected to key areas of Dubai through major roads and public transport links, including the Dubai Metro and the Marina Tram."
      },
      {
        id: "4",
        title: "",
        details: "With its blend of luxury, convenience, and vibrant waterfront living, Marina Cove Apartments is an ideal choice for professionals and families looking for a modern lifestyle in one of Dubai’s most iconic neighborhoods."
      }
    ],
    approximateLocations: [
      "Gym",
      "Central A/C",
      "CCTV Cameras",
      "Covered Parking",
      "Children Play Area"
    ]
  },
  {
    id: "7",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Hillgate-1.webp"),
    subImage: [
      require("../../assets/projects/Hillgate-2.webp"),
    ],
    title: "The Hillgate",
    statues: "Status : Coming Soon",
    price: "Starting From USD 327,000",
    completionDate: "Soon",
    placeName: "The Hillgate",
    area: "763Sqft",
    bedroom: "4",
    locationLink: "https://maps.app.goo.gl/JNq1U4dF1BcVC4Li7",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d115607.19120956802!2d55.383526!3d25.111178!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDA2JzQwLjIiTiA1NcKwMjMnMDAuNyJF!5e0!3m2!1sen!2sus!4v1741114129242!5m2!1sen!2sus",
    overview: [
      {
        id: "1",
        title: "The Hillgate",
        details: "Step into a new era of sophisticated living at The Hillgate in Dubai Silicon Oasis. This latest residential gem combines modern lifestyle with a community-focused design, offering a stylish and practical home for discerning residents. Choose from meticulously designed one- to four-bedroom apartments, set within a lively neighborhood featuring green parks, curated retail outlets, and essential amenities. With quick access to two major highways, residents are just a 20-minute drive from Downtown Dubai, enjoying both a tranquil retreat and seamless connectivity to the heart of the city."
      },
      {
        id: "2",
        title: "",
        details: "The HillGate is a residential project situated in Dubai Silicon Oasis, featuring a variety of 1 to 3-bedroom apartments tailored to meet the demands of modern living. Each apartment is designed with contemporary interiors and premium finishes, offering residents a stylish and comfortable setting. The development includes amenities such as a fully equipped gym, swimming pool, and childrens play area, promoting a well-rounded lifestyle for both families and individuals. Positioned strategically within Dubai Silicon Oasis, The HillGate provides convenient access to major highways, educational institutions, and business centers, making it an excellent choice for those seeking connectivity and convenience in a lively community."
      },
    ],
    approximateLocations: [
      "Gym",
      "Central A/C",
      "CCTV Cameras",
      "Security",
    ]
  },

  // End UAE

  // Start Spain

  {
    id: "8",
    city: "Cortesin Gated Community",
    countries: "Spain",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Spain.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Marea-1.jpg"),
    subImage: [
      require("../../assets/projects/Marea-2.jpg"),
      require("../../assets/projects/Marea-3.jpg"),
      require("../../assets/projects/Marea-4.jpg"),
      require("../../assets/projects/Marea5.jpg"),
    ],
    title: "Marea, Interiors",
    statues: "Status : Under Development",
    price: "Starting From EUR 2,047,830",
    completionDate: "Expected Completion Date 2027",
    placeName: "Marea, Interiors",
    area: "223 to 553",
    bedroom: "2, 3 and 4 bedroom",
    locationLink: "https://maps.app.goo.gl/79ymoVizq8pnx21v5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2576140.8469949327!2d-3.176002756893378!3d37.39781994358281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd72d54743c6f715%3A0xac7f381eab842178!2zMjk2Nzkg2KjZitmG2KfZgdmK2LPYjCDZhdin2YTYp9is2KfYjCDYpdiz2KjYp9mG2YrYpw!5e0!3m2!1sar!2sjo!4v1741115635992!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "In the heart of Cortesin Gated Community",
        details: "Situated in close proximity to Finca Cortesin Resort, Marea is an exclusive residential community thoughtfully crafted to harmonize with the captivating scenery of Costa Del Sol. This luxurious enclave is set against the backdrop of the stunning Mediterranean Sea and an elite golf course. With a strategic location offering a breathtaking 270-degree panorama from Marbella to Gibraltar and Morocco’s mountains, Marea by Missoni provides easy access to the vibrant hub of Marbella and two renowned Mediterranean marinas, Puerto Banús and Sotogrande, just a short 20-minute drive away."
      },
    ],
    approximateLocations: [
      "Waterfront residences",
      "Floor to ceiling windows",
      "Staggered balconies",
      "Interiors",
    ]
  },
  {
    id: "9",
    city: "Benahavís",
    countries: "Spain",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Spain.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Tierra-1.jpg"),
    subImage: [
      require("../../assets/projects/Tierra-2.jpg"),
      require("../../assets/projects/Tierra-3.jpg"),
      require("../../assets/projects/Tierra4.jpg"),
      require("../../assets/projects/Tierra-5.jpg"),
      require("../../assets/projects/Tierra-6.jpg"),
    ],
    title: "Villa",
    statues: "Status : Under Development",
    price: "Starting From EUR 1,221,392",
    completionDate: "Expected Completion Date December 2027",
    placeName: "Tierra Viva",
    area: "700 to 1450",
    bedroom: "4,5,6 Bedrooms",
    locationLink: "https://maps.app.goo.gl/79ymoVizq8pnx21v5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2576140.8469949327!2d-3.176002756893378!3d37.39781994358281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd72d54743c6f715%3A0xac7f381eab842178!2zMjk2Nzkg2KjZitmG2KfZgdmK2LPYjCDZhdin2YTYp9is2KfYjCDYpdiz2KjYp9mG2YrYpw!5e0!3m2!1sar!2sjo!4v1741115635992!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Iconic livings",
        details: "When an iconic territory and an icon of power come together, the supernatural happens.An exclusive gated community of only 53 exclusive luxury villas with design inspired by Automobili Lamborghini. Located in the hills of Benahavis, overlooking Marbella, Tierra Viva rises out from the hills, with endless panoramic views of the Mediterranean Sea and the Andalusian landscape."
      },
      {
        id: "2",
        title: "",
        details: "At the heart of Tierra Viva's allure are The Painite Villas, a showcase of advanced car elevator technology that echoes Lamborghini's innovative spirit. These villas are specifically designed for those who cherish their automotive passions, providing a seamless blend of luxury living and automotive excellence. Owners of The Painite Villas can enjoy the luxury of having their beloved vehicles elevated directly into their living spaces, a feature that redefines the concept of a garage and merges it with the aesthetic of high-end living."
      },
    ],
    approximateLocations: [
      "Waterfront residences",
      "Floor to ceiling windows",
      "Staggered balconies",
      "Interiors",
    ]
  },
  {
    id: "10",
    city: "Benahavís",
    countries: "Spain",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Spain.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Painite-1.jpg"),
    subImage: [
      require("../../assets/projects/Painite-2.jpg"),
      require("../../assets/projects/Painite-3.jpg"),
      require("../../assets/projects/Painite-4.jpg"),
      require("../../assets/projects/Painite-5.jpg"),
      require("../../assets/projects/Painite-6.jpg"),
    ],
    title: "Lamborghini",
    statues: "Status : Under Development",
    price: "Starting From EUR 4,300,000",
    completionDate: "Expected Completion Date December 2027",
    placeName: "Painite Villas Design Inspired",
    area: "700 to 1450",
    bedroom: "4,5,6 Bedrooms",
    locationLink: "https://maps.app.goo.gl/79ymoVizq8pnx21v5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2576140.8469949327!2d-3.176002756893378!3d37.39781994358281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd72d54743c6f715%3A0xac7f381eab842178!2zMjk2Nzkg2KjZitmG2KfZgdmK2LPYjCDZhdin2YTYp9is2KfYjCDYpdiz2KjYp9mG2YrYpw!5e0!3m2!1sar!2sjo!4v1741115635992!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "The Villa",
        details: "The villa boasts six luxurious bedrooms, expansive roof terraces, and panoramic views of the Mediterranean Sea from every angle. Complementing this are the extensive swimming pool and lush, meticulously designed gardens, making the villa a gateway to unparalleled luxury."
      },
      {
        id: "2",
        title: "The Views",
        details: "The Painite Villas are masterfully positioned on the hilltops, where careful leveling ensures that each villa enjoys unobstructed, panoramic views. From this elevated vantage point, the villas offer breathtaking vistas that stretch across the horizon, providing an uninterrupted connection to the surrounding landscape. The strategic placement of these villas maximizes the stunning scenery and creates a sense of serenity and exclusivity."
      },
    ],
    approximateLocations: [
      "Waterfront residences",
      "Floor to ceiling windows",
      "Staggered balconies",
      "Interiors",
    ]
  },

  // End Spain

  // Start Qatar

  {
    id: "12",
    city: "Doha",
    countries: "Qatar",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Qatar.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Les-1.jpg"),
    subImage: [
      require("../../assets/projects/Les-2.jpg"),
      require("../../assets/projects/Les-3.jpg"),
      require("../../assets/projects/Les-4.jpg"),
      require("../../assets/projects/Les-5.jpg"),
      require("../../assets/projects/Les-6.jpg"),
      require("../../assets/projects/Les-7.jpg"),
    ],
    title: "Les Vagues",
    statues: "Status : Under Development",
    price: "Starting From QAR 3,806,060",
    completionDate: "Expected Completion Date Dec 2026",
    placeName: "Les Vagues",
    area: "86 to 389",
    bedroom: "1, 2 & 3-bedrooms",
    locationLink: "https://maps.app.goo.gl/fuzoAWoiqNuqp44F6",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3603.351710240119!2d51.52799252482857!3d25.426502477564057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDI1JzM1LjQiTiA1McKwMzEnMzEuNSJF!5e0!3m2!1sar!2sjo!4v1741116423453!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "A Paradise",
        details: "A lifetime of golden sunsets awaits you at Les Vagues. Situated in Qetaifan Island North, a place of unimaginable beauty, is paradise on earth for haute couture living. Where opulent sea-front residences are nestled alongside luxurious beach resorts, private beaches, clubhouses, world-class boating facilities, boutique shopping experiences, a water park, and a winter garden."
      },

    ],
    approximateLocations: [
      "State Of The Art Fitness Center",
      "Infinity Swimming Pool",
      "4 Personal Elevators, Inclusive Of A Service Elevator To All Floors",
      "Lounges And Lobby Areas: Furniture Designed And Selected",
    ]
  },
  {
    id: "13",
    city: "Doha",
    countries: "Qatar",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Qatar.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Vagues3-1.jpg"),
    subImage: [
      require("../../assets/projects/Vagues3-2.jpg"),
      require("../../assets/projects/Vagues3-3.jpg"),
      require("../../assets/projects/Vagues3-4.jpg"),
      require("../../assets/projects/Vagues3-5.jpg"),
    ],
    title: "Les Vagues 03",
    statues: "Status : Under Development",
    price: "Starting From QAR 5,746,040",
    completionDate: "Expected Completion Date Dec 2027",
    placeName: "Les Vagues 03",
    area: "90 to 358",
    bedroom: "2 bedrooms",
    locationLink: "https://maps.app.goo.gl/fuzoAWoiqNuqp44F6",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3603.351710240119!2d51.52799252482857!3d25.426502477564057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDI1JzM1LjQiTiA1McKwMzEnMzEuNSJF!5e0!3m2!1sar!2sjo!4v1741116423453!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Les Vagues 03",
        details: "The success of Les Vagues 02 at les Vague has led to the opening of Les Vagues 03. Now you can celebrate twice as hard at Les Vagues 03. These beautiful residences are poised to emerge as the epitome of exclusivity. Nestled on the shores of Qetaifan Island North, Les Vagues 03 is an extension of the most thrilling residential project on the island offering a haven of 2-bedroom sea-front residences."
      },
    ],
    approximateLocations: [
      "Waterfront residences",
      "Floor to ceiling windows",
      "Staggered balconies",
      "Interiors",
    ]
  },
  {
    id: "14",
    city: "Doha",
    countries: "Qatar",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Qatar.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/L'Horizon-1.jpg"),
    subImage: [
      require("../../assets/projects/L'Horizon-2.jpg"),
      require("../../assets/projects/L'Horizon-3.jpg"),
      require("../../assets/projects/L'Horizon-4.jpg"),
      require("../../assets/projects/L'Horizon5.jpg"),
      require("../../assets/projects/L'Horizon-6.jpg"),
    ],
    title: "L'Horizon",
    statues: "Status : Under Development",
    price: "Starting From QAR 2,074,345",
    completionDate: "Expected Completion Date Dec 2026",
    placeName: "L'Horizon",
    area: "178 to 245",
    bedroom: "1, 2 &3 - bedrooms",
    locationLink: "https://maps.app.goo.gl/fuzoAWoiqNuqp44F6",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3603.351710240119!2d51.52799252482857!3d25.426502477564057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDI1JzM1LjQiTiA1McKwMzEnMzEuNSJF!5e0!3m2!1sar!2sjo!4v1741116423453!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "An Oasis of Calm and Serenity",
        details: "Dive into the swells of luxury at L'Horizon. Positioned on Qetaifan Island North in Lusail City. These waterfront homes offer unparalleled access to vibrant shopping districts, luxury dining, and entertainment hubs, all within minutes.residents can enjoy bespoke amenities, including an infinity pool, state-of-the-art fitness center, and personalized concierge services, all set against stunning views of the Arabian Gulf and Doha’s iconic skyline."
      },
    ],
    approximateLocations: [
      "State Of The Art Fitness Centre",
      "Infinity Swimming Pool",
      "Landscaped Community Courtyard With Sea Views",
      "A La Carte Concierge Services",
    ]
  },

  // End Qatar

  // Start Oman


  {
    id: "16",
    city: "Muscat",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Trump-Cliff- 1.jpg"),
    subImage: [
      require("../../assets/projects/Trump-Cliff-2.jpg"),
      require("../../assets/projects/Trump-Cliff-3.jpg"),
      require("../../assets/projects/Trump-Cliff-4.jpg"),
      require("../../assets/projects/Trump-Cliff-5.jpg"),
      require("../../assets/projects/Trump-Cliff-6.jpg"),
    ],
    title: "Trump Cliff Villas",
    statues: "Status : Under Development",
    price: "Starting From USD 1,000,000",
    completionDate: "2028",
    placeName: "Trump Cliff Villas",
    area: "128 to 166",
    bedroom: "3 bedroom villas",
    locationLink: "https://maps.app.goo.gl/hUcRn8LSwRB64Eqi9",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d12304.478444188919!2d58.677218157261!3d23.527346804900585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741117910150!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Once in a Lifetime",
        details: "The Trump furnished villas represent the pinnacle of high-society living. Nestled among Trump International Hotel, 130m above the sea level – enjoy direct sea views. These villas are meticulously designed and curated to provide the highest standard of sophisticated living."
      },
    ],
    approximateLocations: [
      "Trump International Golf Club, Oman",
      "Community & Retail Centre",
      "Wellness Centres",
      "Plazas, Cafes & Restaurants",
    ]
  },
  {
    id: "17",
    city: "Muscat",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Rizz-1.jpg"),
    subImage: [
      require("../../assets/projects/Rizz-2.jpg"),
      require("../../assets/projects/Rizz-3.jpg"),
      require("../../assets/projects/Rizz-4.jpg"),
      require("../../assets/projects/Rizz-5.jpg"),
      require("../../assets/projects/Rizz-6.jpg"),
    ],
    title: "Rizz Villas",
    statues: "Status : Under Development",
    price: "Starting From USD 450,000",
    completionDate: "Expected Completion Date 2027",
    placeName: "Rizz Villas",
    area: "125 to 403",
    bedroom: "3 bedrooms",
    locationLink: "https://maps.app.goo.gl/y7RfkCCVyQiKCpmx5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3658.0815543059502!2d58.67769992489187!3d23.529568978821654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741118373604!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "You got the rizz.",
        details: "With a 5-year payment plan, a golden visa and an easy bank account set up its easy to see how you can only strut to the beat of the ocean at Rizz Villas. Located in a gated community and golfing destination 130m above the shores, these villas are crafted with no wrong."
      },
      {
        id: "2",
        title: "",
        details: "Enjoy the sea steps away, the golf course a stone-throw away, and, all the recreational outdoor adventures right outside your door. With the scenic surroundings, coupled with the luxurious interiors, these villas were born to make every moment at the Rizz a rizz escape."
      }
    ],
    approximateLocations: [
      "Trump International Golf Club, Oman - 18hole Golf Course",
      "Club House",
      "Plazas, Cafes & Restaurants",
      "Wellness Centers",
    ]
  },
  {
    id: "18",
    city: "Muscat",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Golf-1.jpg"),
    subImage: [
      require("../../assets/projects/Golf-2.jpg"),
      require("../../assets/projects/Golf-3.jpg"),
      require("../../assets/projects/Golf-4.jpg"),
      require("../../assets/projects/Golf-5.jpg"),
      require("../../assets/projects/Golf-6.jpg"),
    ],
    title: "Trump Golf Villas",
    statues: "Status : Under Development",
    price: "Starting From USD 2,000,000",
    completionDate: "Expected Completion Date December 2028",
    placeName: "Trump Golf Villas",
    area: "4,367",
    bedroom: "5 bedrooms",
    locationLink: "https://maps.app.goo.gl/y7RfkCCVyQiKCpmx5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3658.0815543059502!2d58.67769992489187!3d23.529568978821654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741118373604!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "The power of living",
        details: "The power of living begins 130 meters above the Muscat Riviera, where Trump Golf Villa owners live along the Trump International Golf Club Oman. These breathtaking villas epitomize sophistication and elegance. Owners enjoy a world-class membership to the golf club, as well as, their very own exclusive branded golf cart, empowering residents to enjoy the beautiful game of golf on their own terms."
      },
    ],
    approximateLocations: [
      "Personal Golf Cart",
      "Trump International Golf Club Oman",
      "Community Facilities",
      "Wellness Centres",
    ]
  },
  {
    id: "19",
    city: "Aida",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Fairway-1.jpg"),
    subImage: [
      require("../../assets/projects/Fairway-2.jpg"),
      require("../../assets/projects/Fairway-3.jpg"),
      require("../../assets/projects/Fairway-4.jpg"),
      require("../../assets/projects/Fairway-5.jpg"),
      require("../../assets/projects/Fairway-6.jpg"),
    ],
    title: "Fairway Villas",
    statues: "Status : Under Development",
    price: "Starting From USD  1,277,374",
    completionDate: "Expected Completion Date December 2028",
    placeName: "Fairway Villas",
    area: "288 - 403",
    bedroom: "4 & 5 Bedrooms",
    locationLink: "https://maps.app.goo.gl/y7RfkCCVyQiKCpmx5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3658.0815543059502!2d58.67769992489187!3d23.529568978821654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741118373604!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "For The Love Of Golf",
        details: "Perched 130 meters above the Muscat Riviera, The Fairway Villas are directly situated at the frontlines of the Trump International Golf Club, Oman in AIDA, Muscat. Accessible only to a select few in AIDA, these breathtaking villas epitomize sophistication and elegance. Owners enjoy a world-class membership to the Trump Golf Club, as well as, their very own exclusive branded golf cart, empowering residents to enjoy the beautiful game of golf on their own terms."
      },
    ],
    approximateLocations: [
      "Personal Golf Cart",
      "Trump International Gulf Club Oman",
      "Community Facilities",
      "Plazas, Cafes & Restaurants",
    ]
  },
  {
    id: "20",
    city: "Aida",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Great-1.jpg"),
    subImage: [
      require("../../assets/projects/Great-2.jpg"),
      require("../../assets/projects/Great-3.jpg"),
      require("../../assets/projects/Great-4.jpg"),
      require("../../assets/projects/Great-5.jpg"),
      require("../../assets/projects/Great-6.jpg"),
    ],
    title: "The Great Escape",
    statues: "Status : Under Development",
    price: "Starting From OMR 100,360",
    completionDate: "September 2027",
    placeName: "The Great Escape",
    area: "50 - 375",
    bedroom: "1,2,3 bedrooms",
    locationLink: "https://maps.app.goo.gl/y7RfkCCVyQiKCpmx5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3658.0815543059502!2d58.67769992489187!3d23.529568978821654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741118373604!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "The Thrill of Life on The Edge",
        details: "The Great Escape is a vibrant residential complex within AIDA, one the most beautiful, gated community and golfing destinations in the world. Surrounded, cliffs, and valleys of Muscat, The Great Escape literally rises out of the cliff edges, steps away from the ocean."
      },
    ],
    approximateLocations: [
      "Infinity pool",
      "State-of-the-art gym",
      "Children's swimming pool",
      "Kids play area",
    ]
  },
  {
    id: "21",
    city: "Aida",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Escape-2-1.jpg"),
    subImage: [
      require("../../assets/projects/Escape-2-2.jpg"),
      require("../../assets/projects/Escape-2-3.jpg"),
      require("../../assets/projects/Escape-2-4.jpg"),
      require("../../assets/projects/Escape-2-5.jpg"),
      require("../../assets/projects/Escape-2-6.jpg"),
    ],
    title: "The Great Escape 2",
    statues: "Status : Under Development",
    price: "Starting From OMR 101,690",
    completionDate: "September 2028",
    placeName: "The Great Escape 2",
    area: "49 - 170",
    bedroom: "1,2,3 bedrooms",
    locationLink: "https://maps.app.goo.gl/y7RfkCCVyQiKCpmx5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3658.0815543059502!2d58.67769992489187!3d23.529568978821654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741118373604!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "The Thrill of Living is Back for More",
        details: "After the immense success of The Great Escape 1 and due to popular demand, the thrill is back! Within the vibrant Great Escape residential complex, is now the great Escape 2, rising 9 stories high at the edge of the cliffs, its organic design is directly environment and the adjacent sea."
      },
    ],
    approximateLocations: [
      "Infinity pool",
      "State of the art gym",
      "Children's swimming pool",
      "Kids play area",
    ]
  },
  {
    id: "22",
    city: "Muscat",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Investment-1.jpg"),
    subImage: [
      require("../../assets/projects/Investment-2.jpg"),
      require("../../assets/projects/Investment-3.jpg"),
      require("../../assets/projects/Investment-4.png"),
      require("../../assets/projects/Investment-5.jpg"),
      require("../../assets/projects/Investment-6.jpg"),
    ],
    title: "Coastal Investment Villas",
    statues: "Status : Under Development",
    price: "Starting From USD 477,684",
    completionDate: "Expected Completion Date December 2027",
    placeName: "Coastal Investment Villas",
    area: "125",
    bedroom: "3 bedrooms",
    locationLink: "https://maps.app.goo.gl/y7RfkCCVyQiKCpmx5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3658.0815543059502!2d58.67769992489187!3d23.529568978821654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741118373604!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Missed Mykonos this summer?",
        details: "Situated in AIDA, an exclusive gated community and renowned golfing destination, perched 130 meters above the pristine shores, these villas represent an unparalleled investment opportunity."
      },
      {
        id: "2",
        title: "",
        details: "Positioned so close to the sea that you can feel the refreshing ocean breeze, the Coastal Investment Villas offer an exceptional blend of modern design and timeless craftsmanship."
      },
    ],
    approximateLocations: [
      "Trump International Golf Club Oman – 18hole golf course",
      "Club House",
      "Plazas, Cafes & restaurants",
      "Luxury hotels",
    ]
  },
  {
    id: "23",
    city: "AIDA, Muscat",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Sunrise-1.jpg"),
    subImage: [
      require("../../assets/projects/Sunrise-2.jpg"),
      require("../../assets/projects/Sunrise-3.jpg"),
    ],
    title: "Sunrise Haven Luxury Villas",
    statues: "Status : Under Development",
    price: "Starting From USD 481,688",
    completionDate: "Expected Completion Date December 2028",
    placeName: "Sunrise Haven Luxury Villas",
    area: "125",
    bedroom: "2 - 4",
    locationLink: "https://maps.app.goo.gl/y7RfkCCVyQiKCpmx5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3658.0815543059502!2d58.67769992489187!3d23.529568978821654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741118373604!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "A private escape or an exclusive vacation home rental? You get to decide",
        details: "Situated in AIDA, a renowned golfing destination and exclusive gated community perched 130 meters above Muscat Bay, these villas embody idyllic coastal vibes. Just steps from the sea and mere moments from the golf course, each villa is thoughtfully designed for ultimate relaxation and epic play. Own a villa among the most spectacular stretch of turf and sand – a holiday home to enjoy forever, or to offer as an exclusive vacation home rental."
      },
    ],
    approximateLocations: [
      "Trump International Golf Club Oman",
      "Club House",
      "Plazas, Cafes & restaurants",
      "Luxury hotels",
    ]
  },


  
  {
    id: "24",
    city: "Aida",
    countries: "Oman",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Oman.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Marriott-1.jpg"),
    subImage: [
      require("../../assets/projects/Marriott-2.jpg"),
      require("../../assets/projects/Marriott-3.jpg"),
      require("../../assets/projects/Marriott-4.jpg"),
      require("../../assets/projects/Marriott-6.jpg"),
      require("../../assets/projects/Marriott-7.jpg"),
    ],
    title: "Marriott Residences",
    statues: "Status : Under Development",
    price: "Starting From USD 285,064",
    completionDate: "Expected Completion Date 2028",
    placeName: "Marriott Residences",
    area: "60 - 194",
    bedroom: "1, 2, 3 Bedrooms",
    locationLink: "https://maps.app.goo.gl/y7RfkCCVyQiKCpmx5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3658.0815543059502!2d58.67769992489187!3d23.529568978821654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDMxJzQ2LjUiTiA1OMKwNDAnMzAuNSJF!5e0!3m2!1sar!2sjo!4v1741118373604!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Come Home to Wonderful",
        details: "Come home to the spectacular comfort, exclusivity, and renowned services of Marriott in fully furnished apartments with à la carte services designed to suit your lifestyle. Located in AIDA, these Marriott Reisdences are crafted with exceptional attention to detail and elegantly styled to offer extraordinary experiences amidst one of the world’s most breathtaking settings."
      },
    ],
    approximateLocations: [
      "Championship Golf Course",
      "Plazas, Cafes & Restaurants",
      "Wellness Centers",
      "Fitness Center",
    ]
  },

  // End Oman


  // Start KSA

  {
    id: "25",
    city: "Jeddah",
    countries: "KSA",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/KSA.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Trump-Tower-1.png"),
    subImage: [
      require("../../assets/projects/Trump-Tower-2.jpg"),
      require("../../assets/projects/Trump-Tower-3.jpg"),
      require("../../assets/projects/Trump-Tower-4.jpg"),
      require("../../assets/projects/Trump-Tower-5.jpg"),
      require("../../assets/projects/Trump-Tower-6.jpg"),
    ],
    title: "Trump Tower Jeddah",
    statues: "Status : Under Development",
    price: "Starting From SAR 3,085,838",
    completionDate: "Completion Date December 2029",
    placeName: "Trump Tower Jeddah",
    area: "70 to 365",
    bedroom: "1,2,3,4 Bedroom",
    locationLink: "",
    locationFrameٍٍ: "",
    overview: [
      {
        id: "1",
        title: "Rise Above All",
        details: "Perched up high, Trump Tower Jeddah is the city’s most coveted address. One of the tallest high-rises on the Corniche, it dominates the city, the landmarks and the Red Sea. It rises above all, and all happens around it."
      },
    ],
    approximateLocations: [
      "Uninterrupted Sea Views",
      "Prime Location On the Corniche",
      "Strategic Investment Opportunity",
      "Architectural Landmark",
    ]
  },

  // End KSA

  // Start United Kingdom 

  {
    id: "26",
    city: "Nº149 Old Park Lane",
    countries: "UK",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UK.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Park-1.jpg"),
    subImage: [
      require("../../assets/projects/Park-2.jpg"),
      require("../../assets/projects/Park-3.jpg"),
      require("../../assets/projects/Park-4.jpg"),
      require("../../assets/projects/Park-5.jpg"),
      require("../../assets/projects/Park-6.jpg"),
    ],
    title: "The Mulliner",
    statues: "Status : Completed",
    price: "Starting From 979,381 GBP",
    completionDate: "--",
    placeName: "The Mulliner",
    area: "90 to 358",
    bedroom: "2 - 4",
    locationLink: "https://maps.app.goo.gl/Fmssk25ZvZKmj9Tq8",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d138797.11131900823!2d0.004907233615301621!3d51.538654791586985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876052f7e3074bf%3A0x8b12ab332c1ebb54!2zT2xkIFBhcmsgTG4sIExvbmRvbiwg2KfZhNmF2YXZhNmD2Kkg2KfZhNmF2KrYrdiv2Kk!5e0!3m2!1sar!2sjo!4v1741124200218!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "",
        details: "Originally known as Gloucester House, Nº149 Old Park Lane is a sophisticated landmark building with an important role in London’s architectural heritage."
      },
      {
        id: "2",
        title: "",
        details: "Situated on the corner of Old Park Lane and Piccadilly, overlooking Green Park. Nº149 is one of the finest Grade II properties on Old Park Lane. It has been meticulously redeveloped and designed to the highest of standards throughout."
      },
    ],
    approximateLocations: [
      "Mixed-use Development",
      "Phase 1 completion Date 2027",
      "Units 2 to 4-bedrooms",
      "Area from (sqft) 1,345",
    ]
  },

  // End United Kingdom 


  {
    id: "27",
    city: "New Cairo",
    countries: "Egypt",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Egypt.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/approximateLocations-1.webp"),
    subImage: [
      require("../../assets/projects/approximateLocations-2.webp"),
      require("../../assets/projects/approximateLocations-3.webp"),
    ],
    title: "VIA - Montenapoleone",
    statues: "Status : Completed",
    price: "Starting From USD 94,477",
    completionDate: "Expected Completion Date June 2027",
    placeName: "VIA - Montenapoleone",
    area: "Area(SQM) 485.22",
    bedroom: "5-Bedroom",
    locationLink: "https://maps.app.goo.gl/z1UgdtcMsLZk7xca6",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d18885.912771563657!2d31.6365203!3d30.0533772!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1458234c24c14257%3A0x81771b50706c3799!2sMontenapoleone%20by%20Reportage%20Egypt!5e1!3m2!1sar!2sjo!4v1741165574280!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "",
        details: "In partnership with Al Ahly Sabbour, we are pleased to introduce our first project on Egyptian lands as Egypt, and in one of the most sought-after locations, Mostakbal City – The new heart of New Cairo - ​ Montenapoleone, Spanning over an area of approximately 465.000 m2, the project incorporates a wide range of high-end residential and commercial areas, within 62% open spaces, to offer you the best of what a vibrant life has to offer."
      },
      {
        id: "2",
        title: "",
        details: "Inspired, Italy; which is famous for its fashion, jewelry, and international brands. Designed to be a large open mall that serves Montenapoleone residents and all Mostakbal City, VIA Montenapoleone is considered a microcosm of Italy with its famous fashion street, which will imply a new investment perception in the heart of New Cairo. The mall consists of 6 main buildings (C1,C2, C3,C4,C5,C6) that include administrative offices, retail, and medical clinics. Each building consists of Basement + Ground floor + 2 Floors. Basement floor: Designed and equipped to be a parking area for mall visitors and administrative offices. There are also warehouses and administrative and commercial service areas. Ground Floor is for the Retail 1st & 2nd Floors are for administrative offices and medical clinics"
      },
    ],
    approximateLocations: [
      "Mixed-use Development",
      "Phase 1 completion Date 2027",
      "Units 3 to 7-bedrooms",
      "Area from (sqft) 1,345",
    ]
  },


  {
    id: "30",
    city: "Riyadh",
    countries: "KSA",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/KSA.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Najd-1.jpg"),
    subImage: [
      require("../../assets/projects/Najd-2.jpg"),
      require("../../assets/projects/Najd-3.jpg"),
      require("../../assets/projects/Najd-4.jpg"),
      require("../../assets/projects/Najd-5.jpg"),
      require("../../assets/projects/Najd-6.jpg"),
    ],
    title: "Najd",
    statues: "Status : Under Development",
    price: "Starting From SAR 500,000",
    completionDate: "2027",
    placeName: "Najd",
    area: "90 to 358",
    bedroom: "4 Bedrooms",
    locationLink: "https://maps.app.goo.gl/jFBymD6EwsQCgmKb8",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4455.8743440059425!2d46.80252780000001!3d24.8200278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDQ5JzEyLjEiTiA0NsKwNDgnMDkuMSJF!5e1!3m2!1sar!2sjo!4v1741166858959!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "",
        details: "Najd – a captivating boutique collection of luxurious townhouse villas in the heart of Al Qadisiyah – Riyadh. Modern Italian design aesthetics meet elegance, and convenient luxury meets the most discerning of tastes. With a prime location and within a vibrant community in the heart of the city, Najd One offers a thing to everyone. The luxury community is surrounded, mosque, sports centre, entertainment options and much more"
      },
    ],
    approximateLocations: [
      "Landscape Areas",
      "Retail Area",
      "Store Room",
      "Shopping Center",
    ]
  },

  // Start Türkiye

  {
    id: "31",
    city: "Bahçeşehir’s",
    countries: "Turkiye",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Türkiye.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Afra-1.jpg"),
    subImage: [
      require("../../assets/projects/Afra-2.jpg"),
      require("../../assets/projects/Afra-3.jpg"),
      require("../../assets/projects/Afra4.jpg"),
      require("../../assets/projects/Afra-5.jpg"),
      require("../../assets/projects/Afra-6.jpg"),
    ],
    title: "Afra Park",
    statues: "Status : Under Development",
    price: "Starting From 300,000 $",
    completionDate: "2027",
    placeName: "Afra Park",
    area: "90 to 358",
    bedroom: "2 - 4",
    locationLink: "https://maps.app.goo.gl/DJDfWBoXSJddvpSC9",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3699.53515924151!2d28.683612399999998!3d41.099446799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDA1JzU4LjAiTiAyOMKwNDEnMDEuMCJF!5e1!3m2!1sar!2sjo!4v1741167424411!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "",
        details: "Afra Park lies in one of Istanbul’s most central and connected new communities in Bahçeşehir. Properties aims to build upon the rich architectural heritage of Turkiye, that takes influence from both their European and Asian neighbors to create unparalleled modern cities and lively communities. Afra Parks offers an impeccable collection of sleek townhouses that intertwines the luxury and comfort of urban living with the tranquility of Bahçeşehir’s natural landscapes. Each townhouse within this esteemed community is thoughtfully designed to accommodate their residents with spacious interiors flooded with natural light and luxurious amenities that cater to every aspect of contemporary living."
      },
      {
        id: "2",
        title: "",
        details: "Bahçeşehir has become a new center of modernity and luxury while also harmonizing its communities with the natural beauty present in Istanbul. The central district is located in the European side of the city and is in a prime location connected to some of the most contemporary and prosperous landmarks in Istanbul. Attesting to its impressive urban portfolio, Bahçeşehir has succeeded in building the biggest medical city in Europe becoming an esteemed destination for medical tourism from across the world."
      },
    ],
    approximateLocations: [
      "Swimming Pool",
      "Gym",
      "Landscape Garden",
      "BBQ Areas",
      "Kid's Play Area",
      "Pet Area",
    ]
  },
  {
    id: "32",
    city: "Istanbul",
    countries: "Turkiye",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Türkiye.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Sylvana-1.jpg"),
    subImage: [
      require("../../assets/projects/Sylvana-2.jpg"),
      require("../../assets/projects/Sylvana-3.jpg"),
      require("../../assets/projects/Sylvana-4.jpg"),
      require("../../assets/projects/Sylvana-5.jpg"),
      require("../../assets/projects/Sylvana-6.jpg"),
    ],
    title: "Sylvana",
    statues: "Status : Under Development",
    price: "Starting From 638,000 $",
    completionDate: "2027",
    placeName: "Sylvana",
    area: "90 to 358",
    bedroom: "4 Bedrooms",
    locationLink: "https://maps.app.goo.gl/6SZdVkb2qgd9zZGS9",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3699.6448127406798!2d28.6478889!3d41.0975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDA1JzUxLjAiTiAyOMKwMzgnNTIuNCJF!5e1!3m2!1sar!2sjo!4v1741167574040!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "",
        details: "The district of Modern Infrastructure, with the biggest medical city in Europe and the largest landmarks in Istanbul and Türkiye. With a central location in the very heart of Istanbul and the European side of the city, Başakşehir is closely connected to Istanbul’s landmarks. The newly founded district is considered a city on its own comprising modern residential developments, parks, schools, the biggest stadium in Istanbul and the biggest medical city in Europe, which makes it a renowned destination for medical tourism from all around Europe and the Middle East."
      },
      {
        id: "2",
        title: "",
        details: "A community of brilliantly designed 4-Bedroom townhouses, right in the heart of the fascinating Türkish city of Istanbul. Beauty of nature, modern lifestyle and Italian architecture all meet in one place within a cosmopolitan city that is the sweetheart of visitors from all around the world. SYLVANA offers an incomparable lifestyle for those who seek beauty, relaxation and a vibrant life, and a bit of everything for everyone. Home buyers are also qualified to obtain Türkish Citizenship.",
      }
    ],
    approximateLocations: [
      "Landscape Garden",
      "BBQ Areas",
      "Parking Area",
      "Kid's Play Area",
    ]
  },

  // End Türkiye

  {
    id: "33",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Trump-d-1.webp"),
    subImage: [
      require("../../assets/projects/Trump-d-2.avif"),
    ],
    title: "Trump International Hotel & Tower Dubai",
    statues: "Status : Under Development",
    price: "Starting From AED 1,800,000",
    completionDate: "2027",
    placeName: "Trump International Hotel & Tower Dubai",
    area: "763Sqft",
    bedroom: "3 & 4 & 5",
    locationLink: "https://maps.app.goo.gl/7jr9FenczcKp4JfH6",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4448.628017545583!2d55.234722600000005!3d25.020736099999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDAxJzE0LjciTiA1NcKwMTQnMDUuMCJF!5e1!3m2!1sar!2sjo!4v1741169108868!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "R. Hills The first of upscale signature line – in the heart of Dubai",
        details: "In a community where real connections thrive and authenticity is the keyword, everyday life becomes an experience to celebrate. Nestled in the heart of Dubai yet away from the bustle, R. Hills is a contemporary gated townhouse community tailored to redefine high-end signature living. With timeless designs and world-class amenities, R. Hills offers an unmatched lifestyle for those who seek serenity, and a life of absolute authenticity."
      },
      {
        id: "2",
        title: "Dubailand",
        details: "Designed to be Dubai’s entertainment hub, Dubailand is an unparalleled opportunity for both living and investment. Dubailand stretches out across an immense 3 billion square feet in the heart of the city, making it the largest district in Dubai. The area is divided between a vibrant mix of vast residential communities and popular leisure attractions. Well-known residential projects and communities such as Al Barari and Arabian Ranches fall within this district, as well as the anticipated upcoming mega-project of Mohammed Bin Rashid City, and our very own Rukan community. According to ServiceMarket, a UAE platform for moving and home services, Dubailand, among other suburban communities, has emerged as the most popular neighbourhood in Dubai that residents moved to in the first quarter of 2017."
      },
    ],
    approximateLocations: [
      "Swimming Pool",
      "Seating Areas",
      "Gym",
      "BBQ Areas",
      "Parking Area",
      "andscape Areas",
    ]
  },
  {
    id: "34",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Village-2.jpg"),
    subImage: [
      require("../../assets/projects/Village-2.jpg"),
      require("../../assets/projects/Village-3.jpg"),
      require("../../assets/projects/Village-4.jpg"),
    ],
    title: "Village Dubai",
    statues: "Status : Under Development",
    price: "Starting From USD 419,000",
    completionDate: "2027",
    placeName: "Village Dubai",
    area: "3 billion square feet",
    bedroom: "2 & 3 & 4",
    locationLink: "https://maps.app.goo.gl/3ZMfqzBrfzhWcXxm8",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d17790.749144977144!2d55.2859963!3d25.046682!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6f1de64a9b4b%3A0xfdc7e48466d6a5aa!2sReportage%20Village!5e1!3m2!1sar!2sjo!4v1741170548562!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "",
        details: "Set against the backdrop of Dubai's skyline and next to the Arabian Ranches, Village Dubai features exclusive townhouse villas with stunning white modern facades that exude an air of sophistication and elegance. Each villa is a testament to meticulous craftsmanship, with sleek lines and lavish finishes that create a seamless blend of contemporary luxury and timeless charm. Step inside and be greeted, offering an oasis of tranquillity and comfort."
      },
      {
        id: "2",
        title: "",
        details: "Whether enjoying a dip in the private pool, hosting a gathering in the lush garden, or simply basking in the serene ambiance, residents can relish in the unparalleled beauty that this community has to offer. Beyond the boundaries of this unparalleled community, residents have easy access to Dubai’s world-class shopping malls, fine-dining establishments, and a diverse range of entertainment options."
      },
      {
        id: "3",
        title: "",
        details: "Designed to be Dubai’s entertainment hub, Dubailand is an unparalleled opportunity for both living and investment. Dubailand stretches out across an immense 3 billion square feet in the heart of the city, making it the largest district in Dubai. The area is divided between a vibrant mix of vast residential communities and popular leisure attractions. Well-known residential projects and communities such as Al Barari and Arabian Ranches fall within this district, as well as the anticipated upcoming mega-project of Mohammed Bin Rashid City, and our very own Rukan community."
      },
    ],
    approximateLocations: [
      "Swimming Pool",
      "Gym",
      "Landscape Garden",
      "BBQ Areas",
      "Parking Area",
      "Kid's Swimming Pool",
    ]
  },
  {
    id: "50",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Taormina-1.png"),
    subImage: [
      require("../../assets/projects/Taormina-2.png"),
      require("../../assets/projects/Taormina-3.png"),
      require("../../assets/projects/Taormina-4.png"),
      require("../../assets/projects/Taormina-5.png"),
      require("../../assets/projects/Taormina-6.png"),
    ],
    title: "Taormina Village",
    statues: "Status : Under Development",
    price: "Starting From AED 2,800,000",
    completionDate: "--",
    placeName: "Taormina Village",
    area: "90 to 358",
    bedroom: "3 & 4 & 5",
    locationLink: "https://maps.app.goo.gl/gzggm4t2CX7eA7qj7",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4446.006483712068!2d55.306784!3d25.092976999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDA1JzM0LjciTiA1NcKwMTgnMjQuNCJF!5e1!3m2!1sar!2sjo!4v1741170721599!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "",
        details: "Exquisite community of 838 luxury villas and townhouses where simplicity meets sophistication, and every corner has a unique story to tell. With its pristine white facades and nature’s magical touch of green, Taormina Village promises a life like no other within an integrated community, inspired"
      },
      {
        id: "2",
        title: "",
        details: "A masterpiece of modern architecture that promotes sustainability and harmony. Taormina villas feature a blend of captivating white facades with a vibrant touch of greenery, blurring the boundaries between indoor and outdoor living. The result is a community that provides residents with a nurturing environment of luxury and a deep connection with nature."
      },
    ],
    approximateLocations: [
      "Swimming Pool",
      "Gym",
      "Landscape Garden",
      "BBQ Areas",
    ]
  },

  // 

  // {
  //   id: "33",
  //   city: "Dubai",
  //   countries: "UAE",
  //   propertiesNumber: "10",
  //   image: require("../../assets/image/countres/UAE.jpg"),
  //   propertiesDetails: "",
  //   mainImage: require("../../assets/projects/Trump-d-1.webp"),
  //   subImage: [
  //     require("../../assets/projects/Trump-d-2.avif"),
  //   ],
  //   title: "Trump International Hotel & Tower Dubai",
  //   statues: "Status : Under Development",
  //   price: "Starting From 500,00 $",
  //   completionDate: "2027",
  //   placeName: "Trump International Hotel & Tower Dubai",
  //   area: "763Sqft",
  //   bedroom: "4",
  //   locationLink: "",
  //   locationFrameٍٍ: "",
  //   overview: [
  //     {
  //       id: "1",
  //       title: "Redefining Sophistication in the Heart of Dubai",
  //       details: "Prepare to experience an architectural masterpiece that elevates the skyline of one of the world's most dynamic cities. Trump International Hotel & Tower Dubai combines unparalleled design, luxury living, and breathtaking views, setting a new benchmark for opulence."
  //     },
  //   ],
  //   approximateLocations: [
  //     "Waterfront residences",
  //     "Floor to ceiling windows",
  //     "Staggered balconies",
  //     "Interiors",
  //   ]
  // },
  {
    id: "34",
    city: "Al Marjan Island, RAK",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Astera-1.jpg"),
    subImage: [
      require("../../assets/projects/Astera-2.jpg"),
      require("../../assets/projects/Astera-3.jpg"),
    ],
    title: "The Astera, Interiors",
    statues: "Status : Under Development",
    price: "Starting From AED 2,527,834",
    completionDate: "Expected Completion Date Dec 2028",
    placeName: "The Astera, Interiors",
    area: "61 to 265",
    bedroom: "1 to 3-bedroom",
    locationLink: "https://maps.app.goo.gl/CQDdVWyvzSCGeqx46",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d46780.83480221222!2d55.73653915953964!3d25.71528469766643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDQxJzA1LjkiTiA1NcKwNDQnMzAuMCJF!5e1!3m2!1sar!2sjo!4v1741257747242!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Legendary Collaboration",
        details: "Live the Legacy in these exquisite beachfront residences with Interiors. This unparalleled living experience is the result of a legendary partnership between and Aston Martin, two esteemed names in the realm of performance and ultra-luxury living. Together, they have seamlessly integrated cutting-edge design, technology and timeless artisanal craftsmanship into residences on the water’s edge of Al Marjan Island."
      },
    ],
    approximateLocations: [
      "Direct Beach Access",
      "Premium 24/7 Security",
      "Fitness Center",
      "Spa",
    ]
  },

  {
    id: "35",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/DG1-1.jpg"),
    subImage: [
      require("../../assets/projects/DG1-2.jpg"),
      require("../../assets/projects/DG1-4.jpg"),
      require("../../assets/projects/DG1-5.jpg"),
      require("../../assets/projects/DG1-6.jpg"),
      require("../../assets/projects/DG13.jpg"),
    ],
    title: "DG1",
    statues: "Status : Under Development",
    price: "Starting From AED 3,059,312",
    completionDate: "2026",
    placeName: "DG1",
    area: "126 to 177",
    bedroom: "1, 2, & 3-bedrooms",
    locationLink: "https://maps.app.goo.gl/FkqPG2W5dgXZHSBg8",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4442.792482622269!2d55.266408923945946!3d25.181279832344064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDEwJzUyLjYiTiA1NcKwMTUnNDkuOCJF!5e1!3m2!1sar!2sjo!4v1741258014751!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "For Visionaries Only",
        details: "An exclusive capsule collection of luxury residences made for people who see what others don’t, do what others only dream of, and craft their futures on their own terms. The architecture of DG1 fully reflects its dynamic attitude. Like a haute couture creation, its distinctive twisting profile opens the doors of imagination, inspiring each of us in a different way."
      },
    ],
    approximateLocations: [
      "State-of-the-art Gym",
      "Infinity Swimming Pool",
      "Landscaped Podium",
      "24hrs Reception Desk",
    ]
  },

  {
    id: "36",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Da-1.jpg"),
    subImage: [
      require("../../assets/projects/Da-2.jpg"),
      require("../../assets/projects/Da-3.jpg"),
      require("../../assets/projects/Da-4.jpg"),
      require("../../assets/projects/Da-5.jpg"),
      require("../../assets/projects/Da-6.jpg"),
    ],
    title: "Da Vinci Tower, Interiors",
    statues: "Status : Completed",
    price: "Starting From 1,770,00 $",
    completionDate: "2024",
    placeName: "Da Vinci Tower, Interiors",
    area: "77 to 398",
    bedroom: "2, 3 & 4-bedrooms",
    locationLink: "https://maps.app.goo.gl/52vBWNE1h8gF1w1h9",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4442.612112040697!2d55.286698623945945!3d25.186226832143685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDExJzEwLjQiTiA1NcKwMTcnMDIuOSJF!5e1!3m2!1sar!2sjo!4v1741258331629!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "A unique world premiere",
        details: "Introducing the world’s first residences, the Da Vinci Tower is an architectural marvel designed to captivate. Its striking façade, balanced on a one-of-a-kind geometric structure, creates a dynamic visual effect that commands attention. At its heart lies the pearl—a suspended sphere that adds a touch of wonder to this masterpiece."
      },
      {
        id: "2",
        title: "",
        details: "Rising 19 floors above the Dubai Canal, with three basement levels and a grand ground floor, the tower offers unmatched views of the iconic Burj Khalifa and is just moments from Marasi Business Bay. Located in Downtown Dubai, the Da Vinci Tower features opulent interiors crafted, embodying the meticulous artistry and innovation inspired. This landmark residence is a tribute to the timeless genius that shaped both Pagani's vision and these extraordinary homes."
      },
    ],
    approximateLocations: [
      "State-of-the-art Gym",
      "Rooftop Pool Overlooking Downtown Dubai",
      "Sauna And Steam Rooms",
      "24/7 Concierge Services",
    ]
  },
  {
    id: "37",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/Urban-1.jpg"),
    subImage: [
      require("../../assets/projects/Urban-2.jpg"),
      require("../../assets/projects/Urban-3.jpg"),
      require("../../assets/projects/Urban-4.jpg"),
      require("../../assets/projects/Urban-5.jpg"),
    ],
    title: "Urban Oasis",
    statues: "Status : Completed",
    price: "Starting From AED 14,100,000",
    completionDate: "Completed",
    placeName: "Urban Oasis",
    area: "176",
    bedroom: "1,2 & 3-Bedrooms",
    locationLink: "https://maps.app.goo.gl/5aDL6gv6Ei7uAYGYA",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4442.673416960513!2d55.26206342394592!3d25.18454553221175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDExJzA0LjQiTiA1NcKwMTUnMzQuMiJF!5e1!3m2!1sar!2sjo!4v1741258540013!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Experience the Miami Vibe",
        details: "The best of Miami is now in Dubai. This is the Urban Oasis, where Miami’s mood, vibes, and lifestyle is expertly captured in every detail. Enjoy exclusive waterfront living, with penthouses accessed luxury apartments, first-class amenities, and sweeping views of the city and the canal."
      },
    ],
    approximateLocations: [
      "Cutting-edge Gym",
      "Infinity Pool",
      "Grand Entrance",
      "Retail",
    ]
  },
  {
    id: "38",
    city: "Dubai",
    countries: "UAE",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/UAE.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/W-1.jpg"),
    subImage: [
      require("../../assets/projects/W-2.jpg"),
      require("../../assets/projects/W-3.jpg"),
      require("../../assets/projects/W-4.jpg"),
      require("../../assets/projects/W-5.jpg"),
      require("../../assets/projects/W6.jpg"),
    ],
    title: "W Residences Downtown",
    statues: "Status : Under Development",
    price: "Starting From USD 436,000",
    completionDate: "Expected Completion Date 2025",
    placeName: "W Residences Downtown",
    area: "355",
    bedroom: "1, 2 & 3-bedrooms",
    locationLink: "https://maps.app.goo.gl/CegFzKbd3jt4eR8S7",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4442.507834207346!2d55.28282892394585!3d25.18908643202793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDExJzIwLjciTiA1NcKwMTYnNDguOSJF!5e1!3m2!1sar!2sjo!4v1741258885656!5m2!1sar!2sjo",
    overview: [
      {
        id: "1",
        title: "Vibrant Downtown Living",
        details: "Born out of the bold attitude and 24/7 culture of New York City, W Hotels has defied expectations, broken down all the norms of traditional luxury, and taken luxury to the next level. Its ultra-exquisite W Residences Dubai-Downtown is situated in the beating heart of Dubai’s vibrant life, with the iconic Burj Khalifa just outside your window and the Dubai Mall and Dancing Fountains only a few steps away."
      },
    ],
    approximateLocations: [
      "Clubhouse",
      "Complimentary Guest Suites",
      "Cutting Edge Fitness Centre",
      "Communications Space With A Private Cinema",
    ]
  },

  // Start Pakistan - Lahore

  // {
  //   id: "28",
  //   city: "Lahore",
  //   countries: "Pakistan",
  //   propertiesNumber: "10",
  //   image: require("../../assets/image/countres/Pakistan.jpg"),
  //   propertiesDetails: "",
  //   mainImage: require("../../assets/projects/Pakistan-1.webp"),
  //   subImage: [
  //     require("../../assets/projects/Pakistan-2.webp"),
  //     require("../../assets/projects/Pakistan-3.webp"),
  //     require("../../assets/projects/Pakistan-4.jpg"),
  //   ],
  //   title: "Skyline Towers",
  //   statues: "Status : Under Development",
  //   price: "Starting From 6,319,050 PKR",
  //   completionDate: "2027",
  //   placeName: "Skyline Towers",
  //   area: "90 to 358",
  //   bedroom: "2 - 4",
  //   locationLink: "https://maps.app.goo.gl/fV5QGgGx4PiZyvVW7",
  //   locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4934.7159908821595!2d55.271578299999994!3d25.2237096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDEzJzI1LjQiTiA1NcKwMTYnMTcuNyJF!5e1!3m2!1sar!2sjo!4v1741165924745!5m2!1sar!2sjo",
  //   overview: [
  //     {
  //       id: "1",
  //       title: "",
  //       details: "Skyline Towers are a contemporary residential development in Chahar Bagh, Lahore, Pakistan. which is a mixed-use building that aims to create a dynamic environment where living, working, and leisure seamlessly coexist."
  //     },
  //     {
  //       id: "2",
  //       title: "",
  //       details: "Designed to deliver an exceptional lifestyle that provides a perfect fusion of elegance, comfort, and convenience. "
  //     },
  //     {
  //       id: "3",
  //       title: "",
  //       details: "Chahar Bagh community takes its historical name from the Mughal era, perfectly blending our traditional past with the concept of contemporary & modern living It’s the Ravi Urban Development Authority’s (RUDA) inaugural project, consisting of cutting-edge mixed-use and exclusive Villas The community offers economical, highly secured and swift connectivity to the basic necessities of sustainable living."
  //     },
  //   ],
  //   approximateLocations: [
  //     "Factsheet",
  //     "Unit Types Sheet",
  //     "Floor Plan",
  //     "--",
  //   ]
  // },

  // End Pakistan - Lahore

  // Start Rwanda
  // {
  //   id: "29",
  //   city: "Jasmine",
  //   countries: "Rwanda",
  //   propertiesNumber: "10",
  //   image: require("../../assets/image/countres/Rwanda.jpg"),
  //   propertiesDetails: "",
  //   mainImage: require("../../assets/projects/Jasmine-1.jpg"),
  //   subImage: [
  //     require("../../assets/projects/Jasmine2.jpg"),
  //     require("../../assets/projects/Jasmine-3.jpg"),
  //     require("../../assets/projects/Jasmine-4.jpg"),
  //     require("../../assets/projects/Jasmine-5.jpg"),
  //   ],
  //   title: "Jasmine Hills",
  //   statues: "Status : Under Development",
  //   price: "Starting From 296,736 $",
  //   completionDate: "--",
  //   placeName: "Jasmine Hills",
  //   area: "90 to 358",
  //   bedroom: "2 - 4",
  //   locationLink: "https://maps.app.goo.gl/Ufs9XVvCrHpW5toZ7",
  //   locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d77913.6084992579!2d-78.58768254747015!3d7.295703713291928!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zN8KwMTgnNDYuNCJOIDc4wrAzNicyOC4xIlc!5e1!3m2!1sar!2sjo!4v1741166308188!5m2!1sar!2sjo",
  //   overview: [
  //     {
  //       id: "1",
  //       title: "",
  //       details: "Jasmine Hills is a captivating and exclusive collection of upscale townhouses in the heart of Kigali City in Rwanda Jasmine Hills has a Blending modern Italian design with elegance and comfortable luxury to meet the most distinguished tastes delivering the whole luxury lifestyle with luxury lifestyle living. Thanks to its prime location which is surrounded Sports Center, Schools, Modern Retails, Cafes & Restaurants. Jasmine Hills contains 59 townhouses. In terms of design, quality, and space, they have all been built to the highest international standards."
  //     },
  //   ],
  //   approximateLocations: [
  //     "Swimming Pool",
  //     "Gym",
  //     "Landscape Garden",
  //     "Kid's Play Area",
  //   ]
  // },

  // End Rwanda

  {
    id: "39",
    city: "Trabzon",
    countries: "Turkiye",
    propertiesNumber: "10",
    image: require("../../assets/image/countres/Türkiye.jpg"),
    propertiesDetails: "",
    mainImage: require("../../assets/projects/marincitytrabzon-1.jpg"),
    subImage: [
      require("../../assets/projects/marincitytrabzon-2.jpg"),
      require("../../assets/projects/marincitytrabzon-3.jpg"),
      require("../../assets/projects/marincitytrabzon-4.jpg"),
      require("../../assets/projects/marincitytrabzon-5.jpg"),
      require("../../assets/projects/marincitytrabzon-6.jpg"),
      require("../../assets/projects/marincitytrabzon-7.jpg"),
      require("../../assets/projects/marincitytrabzon-8.jpg"),
    ],
    title: "Marina city Trabzon",
    statues: "Status : Under Development",
    price: "Starting From 298,000 $",
    completionDate: "2027",
    placeName: "Marina city Trabzon",
    area: "+175",
    bedroom: "4",
    locationLink: "https://maps.app.goo.gl/p2vApSqpCVUij5Wx5",
    locationFrameٍٍ: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d29658.508249789877!2d39.850793!3d40.96116000000001!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40643a79128c40bd%3A0xcf5f57dca3d12dbb!2sMarincity%20Trabzon%20Sat%C4%B1%C5%9F%20Ofisi%20(Sales%20Office)!5e1!3m2!1str!2str!4v1742903498520!5m2!1str!2str",
    overview: [
      {
        id: "1",
        title: "Luxury and comfort standards redefined",
        details: "Marincity Trabzon is a unique living space where all members of your family, from the youngest to the oldest, will spend quality time in peace and security. The vast landscape area of ​​the project, where blue and green meet, offers you all the social opportunities you are looking for. While you sip your coffee in the Main Lounge, your children can have fun in the Kids Club right next to it. You can do sports on the open courts, and relieve the tiredness of the day in the swimming pool or sauna. Take the opportunity to transform this privileged life, which goes beyond dreams, into your daily routine one of the apartments with a magnificent sea view in the project."
      },
      {
        id: "2",
        title: "A Rare Location That Adds Value to Its Value",
        details: "Recreation, shopping, tourism, education, health, transportation facilities and services are right next to your seafront residence. Access all the opportunities of city life within minutes from a privileged location where nature and the sea meet. In Trabzon, the gateway of our Black Sea region to the world, with rapidly rising tourism and a growing economy, Marincity Trabzon promises you much more for the future."
      },
    ],
    approximateLocations: [
      "Playland",
      "Swimming Pools",
      "Turkish Bath",
      "Bike Path",
      "Walking Path",
      "Children's Playground",
    ]
  },
];

export default propertiesSectionData;
